import AsyncStorage from '@react-native-async-storage/async-storage';
import { DefaultTheme, NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Platform } from 'react-native';

import PantryScreen from '../screens/PantryScreen';
import ScreenZero from '../screens/ScreenZero';
import AccountCreatedScreen from '../screens/register/AccountCreatedScreen';
import AdditionalDetailsScreen from '../screens/register/AdditionalDetailsScreen';
import CreatePasswordScreen from '../screens/register/CreatePasswordScreen';
import EmailUnsubscribedScreen from '../screens/register/EmailUnsubscribedScreen';
import EmailVerifiedScreen from '../screens/register/EmailVerifiedScreen';
import EnterEmailScreen from '../screens/register/EnterEmailScreen';
import EnterPasswordScreen from '../screens/register/EnterPasswordScreen';
import EnterPhoneScreen from '../screens/register/EnterPhoneScreen';
import FamilyDetailsScreen from '../screens/register/FamilyDetailsScreen';
import LanguageScreen from '../screens/register/LanguageScreen';
import LoginByMagicLinkScreen from '../screens/register/LoginByMagicLinkScreen';
import LogoutScreen from '../screens/register/LogoutScreen';
import OtpCodeScreen from '../screens/register/OtpCodeScreen';
import PhoneOrEmailScreen from '../screens/register/PhoneOrEmailScreen';
import ResetPasswordScreen from '../screens/register/ResetPasswordScreen';
import ResetPasswordSentScreen from '../screens/register/ResetPasswordSentScreen';
import TermsPrivacyScreen from '../screens/register/TermsPrivacyScreen';
import UserDetailsScreen from '../screens/register/UserDetailsScreen';
import VerificationEmailSentScreen from '../screens/register/VerificationEmailSentScreen';
import BottomTabNavigator from './BottomTabNavigator';
import LinkingConfiguration from './LinkingConfiguration';
import TopMenuNavigator from './TopMenuNavigator';

import Colors from '../constants/Colors';
import Layout from '../constants/Layout';
import Plentiful from '../constants/Plentiful';
import { wrapper } from '../utils/asyncFunctions';

const Stack = createStackNavigator();
const MyTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    background: Colors.lightBackground,
  },
};

class Router extends Component {
  static propTypes = {
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor() {
    super();
    this.state = { onboarded: false };
  }

  componentDidMount = async () => {
    const [error, onboarded] = await wrapper(AsyncStorage.getItem('onboarded'));
    if (error) console.log('Router:componentDidMount', { error });
    this.setState({ onboarded: !!onboarded });
  };

  componentDidUpdate = async () => {
    const [error, onboarded] = await wrapper(AsyncStorage.getItem('onboarded'));
    if (error) console.log('Router:componentDidUpdate', { error });
    if (!!onboarded !== this.state.onboarded) {
      this.setState({ onboarded: !!onboarded });
    }
  };

  render() {
    const appNav = Platform.OS === 'web' && !Layout.usePantryTabs ? TopMenuNavigator : BottomTabNavigator;

    const screens = [
      <Stack.Screen key="ScreenZero" name="ScreenZero">
        {(props) => <ScreenZero {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="a" name="a" component={appNav} />,
      <Stack.Screen key="Pantry" name="Pantry">
        {(props) => <PantryScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="Language" name="Language">
        {(props) => <LanguageScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="PhoneOrEmail" name="PhoneOrEmail">
        {(props) => <PhoneOrEmailScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="VerificationEmailSent" name="VerificationEmailSent">
        {(props) => <VerificationEmailSentScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="CreatePassword" name="CreatePassword">
        {(props) => <CreatePasswordScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="EnterPassword" name="EnterPassword">
        {(props) => <EnterPasswordScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="EnterPhone" name="EnterPhone">
        {(props) => <EnterPhoneScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="EnterEmail" name="EnterEmail">
        {(props) => <EnterEmailScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="LoginByMagicLink" name="LoginByMagicLink">
        {(props) => <LoginByMagicLinkScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="TermsPrivacy" name="TermsPrivacy">
        {(props) => <TermsPrivacyScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="EmailVerified" name="EmailVerified">
        {(props) => <EmailVerifiedScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="EmailUnsubscribed" name="EmailUnsubscribed">
        {(props) => <EmailUnsubscribedScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="OtpCode" name="OtpCode">
        {(props) => <OtpCodeScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="UserDetails" name="UserDetails">
        {(props) => <UserDetailsScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="FamilyDetails" name="FamilyDetails">
        {(props) => <FamilyDetailsScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="AdditionalDetails" name="AdditionalDetails">
        {(props) => <AdditionalDetailsScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="AccountCreated" name="AccountCreated">
        {(props) => <AccountCreatedScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="ResetPassword" name="ResetPassword">
        {(props) => <ResetPasswordScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="ResetPasswordSent" name="ResetPasswordSent">
        {(props) => <ResetPasswordSentScreen {...props} />}
      </Stack.Screen>,
      <Stack.Screen key="Logout" name="Logout">
        {(props) => <LogoutScreen {...props} />}
      </Stack.Screen>,
    ];

    return (
      <NavigationContainer linking={LinkingConfiguration} theme={MyTheme}>
        <Stack.Navigator
          initialRouteName="ScreenZero"
          screenOptions={{
            title: Plentiful.TITLE,
            headerShown: false,
          }}
        >
          {screens}
        </Stack.Navigator>
      </NavigationContainer>
    );
  }
}

export default Router;
